import { Action, combineReducers } from 'redux';

import { ListResult } from '../../ts/fetchers/ListResult';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { HomeSucceededAction, isCloseWelcomeScreenAction, isHomeAddFavoriteSucceededAction, ishomeFetchFavoritesSucceededAction, ishomeFetchPopularSucceededAction, ishomeFetchRecentsSucceededAction, isHomeRemoveFavoriteSucceededAction } from '../actions/HomeActions';
import { ChannelState, HomeState, WelcomeScreenState } from '../types/HomeTypes';
import { favoritesContentReducer, popularContentReducer, recentsContentReducer, recommendationsContentReducer } from './ChannelContentReducer';
import { normalizedContentKey, normalizedContentReducer } from './NormalizedContentReducer';

export function welcomeScreenReducer(previousState: boolean = false, action: Action): WelcomeScreenState {
  if (isCloseWelcomeScreenAction(action)) {
    return true;
  }
  return previousState;
}

export const homeReducer: (previousState: HomeState, action: Action) => HomeState = combineReducers<HomeState>({
  contentById: normalizedContentReducer,
  favorites: favoritesContentReducer,
  recents: recentsContentReducer,
  popular: popularContentReducer,
  recommendations: recommendationsContentReducer,
  userClosedWelcomeScreen: welcomeScreenReducer
});
